import { AppConstants } from "../app/appConstants"
import { defaultValuesForEnvironment } from "./default-values-for-environment";

export const environment = {
  ...defaultValuesForEnvironment,
  ANIMATIONS: AppConstants.ANIMATIONS, // Animations of some components
  production: true,
  envName: 'hasis',
  // BACKURL: 'https://hsfdappodev.commonms.com/ppo-back/',
  BACKURL: '/',
  // BACKURL: 'http://localhost:8080/PatientPortalHasis/',
  LOGO: 'assets/img/logoHUSFDA.png',
  ADDRESS: 'Calle de Joaquín Costa, 28, 28002 Madrid',
  NAME: 'Hospital Universitario San Francisco de Asís ',
  PHONE: '915 61 71 00',
  EMAIL: 'hsfda@hsfda.com',
  MAILTOCOMUNICATIONS: 'webmaster@commonms.com',
  HIDELANGUAGESELECTOR: true,
  DEFAULTLANGUAGE: 'es',
  HASMYDEPENTS: true,
  HASMYDOCUMENTS: true,
  OPTIONAL_FIELDS_FOR_BOOKAPPOINTMENTS: {
    SUBDEPARTMENT: false,
    TIMEFRAME: false
  },
  OPTIONAL_FIELDS_FOR_REGISTER: {
    STATE: false,
    SOCIAL_SECURITY_NUMBER: false,
    DOCNUMBER: false,
    GENDER: true,
    LANGUAGE: false,
    SECOND_SURNAME: true
  }
};